// Generated by CoffeeScript 2.4.1
(function() {
  var GET, POST, Weaver, WeaverObject, WeaverTransaction, cuid;

  cuid = require('cuid');

  Weaver = require('./Weaver');

  WeaverObject = require('./WeaverObject');

  GET = Weaver.GET;

  POST = Weaver.POST;

  WeaverTransaction = class WeaverTransaction extends WeaverObject {
    constructor() {
      super(cuid());
    }

    // Deprecated: use setTtlSeconds instead
    setTtl(ttlMillis) {
      return this.setTtlSeconds(Math.ceil(ttlMillis / 1000));
    }

    setTtlSeconds(ttl) {
      return this._ttlSeconds = ttl;
    }

    setLockTimeoutSeconds(t) {
      return this._lockTimeoutSeconds = t;
    }

    setBranch(branch) {
      return this._branch = branch;
    }

    getBranch() {
      return this._branch;
    }

    setProject(project) {
      return this._project = project;
    }

    getProject() {
      return this._project;
    }

    async begin() {
      return (await GET("transaction.begin", {
        id: this.id(),
        ttlSeconds: this._ttlSeconds,
        branch: this._branch,
        lockTimeoutSeconds: this._lockTimeoutSeconds
      }, this._project));
    }

    async rollback() {
      try {
        return (await GET("transaction.rollback", {
          id: this.id()
        }, this._project));
      } finally {
        delete Weaver.getCoreManager().currentOpenResultSets[this.id()];
        delete Weaver.getCoreManager().transactionMap[this.id()];
      }
    }

    async commit() {
      try {
        return (await GET("transaction.commit", {
          id: this.id()
        }, this._project));
      } finally {
        delete Weaver.getCoreManager().currentOpenResultSets[this.id()];
        delete Weaver.getCoreManager().transactionMap[this.id()];
      }
    }

    // Deprecated: use keepAliveSeconds instead
    async keepAlive(ttlMillis) {
      return (await this.keepAliveSeconds(Math.ceil(ttlMillis / 1000)));
    }

    async keepAliveSeconds(ttlSeconds) {
      return (await GET("transaction.keepAlive", {
        id: this.id(),
        ttlSeconds
      }, this._project));
    }

  };

  // Export
  module.exports = WeaverTransaction;

}).call(this);
